module.exports = __webpack_public_path__ + "Gotham-Black.14b3a355f612d6181e89.otf";


//////////////////
// WEBPACK FOOTER
// /Users/vijay/projects/customers-app/src/assets/fonts/gotham/Gotham-Black.otf
// module id = ../../../../../src/assets/fonts/gotham/Gotham-Black.otf
// module chunks = styles